/* Planeta 3D v3 · "Planeta OS" — comportamiento de la portada.
   Modo día/noche con amanecer/atardecer, planeta (noche: puntos 2D · día: WebGL o imagen), sistemas fijados,
   contadores, títulos que se decodifican, escaneo de imágenes y el léxico de movimiento de los botones. */
(function () {
  'use strict';
  var root = document.documentElement;
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var seg = function (t, a, b) { return clamp((t - a) / (b - a), 0, 1); };
  var eo = function (t) { return 1 - Math.pow(1 - t, 3); };
  var eio = function (t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  var onView = function (els, fn, opts) {
    if (!('IntersectionObserver' in window)) { els.forEach(fn); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); fn(e.target); } }); }, opts || { rootMargin: '0px 0px -12% 0px' });
    els.forEach(function (el) { io.observe(el); });
  };

  /* La cabecera de Dawn es fija: los capítulos fijados empiezan debajo de ella */
  function hdr() {
    var h = document.querySelector('.section-header'), v = 0;
    if (h) { var cs = getComputedStyle(h); if (cs.position === 'sticky' || cs.position === 'fixed') v = Math.round(h.getBoundingClientRect().height); }
    root.style.setProperty('--v3-hdr', v + 'px');
  }
  hdr(); window.addEventListener('resize', hdr);

  /* ================= Modo día / noche ================= */
  var mode = root.getAttribute('data-mode') === 'night' ? 'night' : 'day';
  function syncUI() {
    var day = mode === 'day';
    $$('[data-v3-toggle]').forEach(function (t) { t.classList.toggle('is-day', day); t.setAttribute('aria-checked', day ? 'true' : 'false'); });
    $$('[data-v3-mode-lbl]').forEach(function (l) { l.textContent = day ? 'Día' : 'Noche'; });
    $$('[data-v3-mode-ro]').forEach(function (l) { l.textContent = 'Modo · ' + (day ? 'Día' : 'Noche'); });
  }
  function setMode(to) { mode = to; root.setAttribute('data-mode', to); syncUI(); }
  syncUI();
  function softFlip(to) { root.classList.add('v3-mode-anim'); setMode(to); setTimeout(function () { root.classList.remove('v3-mode-anim'); }, 950); }

  var sky = null; // se define abajo si la portada tiene cielo
  function switchMode() {
    var to = mode === 'day' ? 'night' : 'day';
    try { localStorage.setItem('p3d-mode', to); } catch (e) {}
    var ann = $('[data-v3-announce]'); if (ann) ann.textContent = to === 'day' ? 'Modo día activado' : 'Modo noche activado';
    $$('[data-v3-toggle]').forEach(function (t) { t.classList.remove('is-hop'); void t.offsetWidth; t.classList.add('is-hop'); });
    if (sky && sky.run(to)) return;
    softFlip(to); if (sky) sky.settle(to);
  }
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-v3-toggle]')) switchMode(); });

  /* ================= Cielo + planeta (00 Arranque) ================= */
  var skyEl = $('[data-v3-sky]');
  if (skyEl) sky = (function (el) {
    var bg = $('[data-v3-skybg]', el), sc = $('[data-v3-stars]', el), sctx = sc.getContext('2d'), sun = $('[data-v3-sun]', el), moon = $('[data-v3-moon]', el);
    var box = $('[data-v3-planet]', el), pc = $('[data-v3-night]', box), pctx = pc.getContext('2d'), dCanvas = $('[data-v3-day]', box), dImg = $('[data-v3-dayimg]', box), hud = $('[data-v3-hud]', el);
    var SW = 0, SH = 0, PW = 0, PH = 0;
    var KF_DAY = [[0, [11, 10, 18], [24, 20, 44]], [.32, [46, 26, 96], [150, 72, 170]], [.55, [150, 90, 190], [249, 135, 132]], [.78, [196, 206, 240], [240, 222, 222]], [1, [214, 226, 243], [243, 245, 249]]];
    var KF_NIGHT = [[0, [214, 226, 243], [243, 245, 249]], [.25, [240, 214, 180], [255, 190, 120]], [.48, [221, 120, 90], [221, 51, 153]], [.72, [70, 34, 110], [110, 40, 120]], [1, [11, 10, 18], [24, 20, 44]]];
    function kf(list, t) {
      for (var i = 1; i < list.length; i++) if (t <= list[i][0]) {
        var a = list[i - 1], b = list[i], u = (t - a[0]) / (b[0] - a[0]);
        return [a[1].map(function (v, k) { return Math.round(lerp(v, b[1][k], u)); }), a[2].map(function (v, k) { return Math.round(lerp(v, b[2][k], u)); })];
      }
      var l = list[list.length - 1]; return [l[1], l[2]];
    }
    function setSky(c) { bg.style.background = 'linear-gradient(180deg,rgb(' + c[0].join(',') + '),rgb(' + c[1].join(',') + '))'; }
    // los astros recorren un arco: salen por la izquierda (este) y se ponen por la derecha (oeste)
    function arc(deg) { var r = deg * Math.PI / 180; return { x: SW * .5 + SW * .47 * Math.cos(r), y: SH - SH * .82 * Math.sin(r) }; }
    function place(n, deg, op) { var p = arc(deg); n.style.transform = 'translate(' + p.x + 'px,' + p.y + 'px)'; n.style.opacity = op; }
    var SUN_REST = 80, MOON_REST = 84; // ambos descansan arriba a la izquierda del planeta, fuera del titular
    function restLums() { if (mode === 'day') { place(sun, SUN_REST, 1); place(moon, 0, 0); } else { place(moon, MOON_REST, 1); place(sun, 0, 0); } }
    var stars = [], night = mode === 'night' ? 1 : 0;
    function drawStars(now) {
      sctx.clearRect(0, 0, SW, SH); if (night <= .001) return;
      for (var i = 0; i < stars.length; i++) {
        var s = stars[i], a = clamp((night - s.th * .65) / .35, 0, 1); if (a <= 0) continue;
        a *= RM ? .8 : (.55 + .45 * Math.sin(now * .0018 + s.ph)); sctx.globalAlpha = a; sctx.fillStyle = '#fff';
        sctx.beginPath(); sctx.arc(s.x * SW, s.y * SH, s.r, 0, 6.283); sctx.fill();
      }
      sctx.globalAlpha = 1;
    }

    /* Noche: la trayectoria de impresión en puntos (misma geometría que el planeta de día) */
    var LAYERS = 64, CUT = [0, .24, .47, .66], TILT = .62, RING_RX = Math.PI / 2 + .42, RING_RZ = .3, RING_R = [1.36, 1.425];
    var COLS = ['#F98784', '#F9CC53', '#8FDCA9', '#4CB3E8', '#AC84DB'], RINGS = 24, pts = [], cz = Math.cos(TILT), sz = Math.sin(TILT);
    for (var i = 0; i < RINGS; i++) {
      var phi = -Math.PI / 2 + Math.PI * (i + .5) / RINGS, rr = Math.cos(phi), y = Math.sin(phi), n = Math.max(10, Math.round(rr * 92)), uu = 1 - (i + .5) / RINGS, band = 0;
      for (var bb = 0; bb < 4; bb++) if (uu >= CUT[bb]) band = bb;
      for (var k = 0; k < n; k++) { var a = k / n * 6.2832, x = rr * Math.cos(a), z = rr * Math.sin(a); pts.push([x * cz - y * sz, x * sz + y * cz, z, band, i]); }
    }
    var cr = Math.cos(RING_RX), sr = Math.sin(RING_RX), crz = Math.cos(RING_RZ), srz = Math.sin(RING_RZ);
    RING_R.forEach(function (R) { for (var q = 0; q < 230; q++) { var b = q / 230 * 6.2832, x0 = R * Math.cos(b), y0 = R * Math.sin(b), y1 = y0 * cr, z1 = y0 * sr; pts.push([x0 * crz - y1 * srz, x0 * srz + y1 * crz, z1, 4, RINGS]); } });
    var dot = { fade: mode === 'night' ? 1 : 0, swell: 1, prog: 1 }, pmx = 0, pmy = 0, buf = [], dotsClear = false;
    el.addEventListener('pointermove', function (e) {
      var r = box.getBoundingClientRect(); pmx = clamp((e.clientX - r.left) / r.width - .5, -.8, .8); pmy = clamp((e.clientY - r.top) / r.height - .5, -.8, .8);
      if (!RM) { box.style.setProperty('--pry', (pmx * 18).toFixed(1) + 'deg'); box.style.setProperty('--prx', (-pmy * 12).toFixed(1) + 'deg'); } // imagen de respaldo: inclinación 3D
    });
    el.addEventListener('pointerleave', function () { box.style.setProperty('--pry', '0deg'); box.style.setProperty('--prx', '0deg'); });
    function drawDots(now) {
      if (dot.fade <= .001) { if (!dotsClear) { pctx.clearRect(0, 0, PW, PH); dotsClear = true; } return; }
      dotsClear = false; pctx.clearRect(0, 0, PW, PH);
      var s = Math.min(PW, PH) * .318, cx = PW / 2, cy = PH / 2, ay = -.35 + (RM ? 0 : now * .00012) + pmx * .5, ax = .06 + pmy * .3;
      var ca = Math.cos(ay), sa = Math.sin(ay), cb = Math.cos(ax), sb = Math.sin(ax), lim = dot.prog * (RINGS + 1);
      buf.length = 0;
      for (var p = 0; p < pts.length; p++) {
        var o = pts[p]; if (o[4] > lim) continue;
        var X = o[0] * ca + o[2] * sa, Z = -o[0] * sa + o[2] * ca, Y = o[1] * cb - Z * sb; Z = o[1] * sb + Z * cb;
        var f = 7.4 / (7.4 - Z); buf.push([cx + X * s * f, cy - Y * s * f, Z, o[3], o[4] > lim - 1]);
      }
      buf.sort(function (a, b) { return a[2] - b[2]; });
      for (var u = 0; u < buf.length; u++) {
        var d = buf[u], dep = clamp((d[2] + 1.5) / 3, 0, 1); pctx.globalAlpha = dot.fade * (.22 + .78 * dep);
        pctx.fillStyle = (d[4] && dot.prog < 1) ? '#FFFFFF' : COLS[d[3]]; var q2 = (1.1 + dep * 1.9) * dot.swell; pctx.fillRect(d[0] - q2 / 2, d[1] - q2 / 2, q2, q2);
      }
      pctx.globalAlpha = 1;
    }

    /* Día: pieza impresa AMS en WebGL (escritorio) o imagen con revelado de impresión (móvil / movimiento reducido) */
    var day = { api: null, loading: false, op: mode === 'day' ? 1 : 0, prog: 1 };
    var GL_OK = !RM && window.matchMedia('(min-width: 900px) and (pointer: fine)').matches;
    function applyDayOp() { if (day.api) { dCanvas.style.opacity = day.op; dImg.style.opacity = 0; } else { dImg.style.opacity = day.op; dCanvas.style.opacity = 0; } }
    applyDayOp();
    function loadDay() {
      if (!GL_OK || day.loading) return; day.loading = true;
      // Shopify minimiza los .js del tema y convierte import() en require(): cargamos con un <script type="module"> en línea.
      var fail = function (err) { if (window.console) console.warn('[p3d-v3] planeta WebGL no disponible, se usa imagen:', err); GL_OK = false; day.loading = false; applyDayOp(); };
      window.__p3dDay = function (T, createDay) {
        try {
          day.api = createDay(T, dCanvas, { layers: LAYERS, cut: CUT, tilt: TILT, ringRx: RING_RX, ringRz: RING_RZ, ringR: RING_R });
          if (mode === 'day' && !anim) day.api.print(1);
          applyDayOp(); start();
        } catch (err) { fail(err); }
      };
      var sc = document.createElement('script'); sc.type = 'module';
      sc.textContent = 'import*as T from ' + JSON.stringify(box.getAttribute('data-three')) + ';import{createDay}from ' + JSON.stringify(box.getAttribute('data-daymod')) + ';window.__p3dDay(T,createDay);';
      sc.addEventListener('error', fail); document.head.appendChild(sc);
      setTimeout(function () { if (!day.api && day.loading) fail('tiempo de espera'); }, 15000);
    }
    function staticPrint() { box.classList.remove('is-printing'); void box.offsetWidth; box.classList.add('is-printing'); }
    function setHud() {
      if (!hud) return;
      hud.textContent = mode === 'day' || (anim && anim.to === 'day')
        ? 'Capa ' + ('0' + Math.round(day.prog * LAYERS)).slice(-2) + '/' + LAYERS + ' · PLA Matte'
        : 'Trayectoria · ' + Math.round(dot.prog * pts.length).toLocaleString('es-MX') + ' pts';
    }

    /* Bucle (sólo mientras el cielo está en pantalla) */
    var visible = true, running = false, anim = null;
    function frame(now) {
      if (!visible) { running = false; return; }
      if (anim) stepAnim(now);
      drawStars(now); drawDots(now);
      if (day.api && day.op > .001) day.prog = day.api.render(now, pmx, pmy);
      setHud();
      requestAnimationFrame(frame);
    }
    function start() { if (!running && !RM) { running = true; requestAnimationFrame(frame); } }
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; if (visible) start(); }).observe(el);

    /* Coreografía amanecer / atardecer (2.1 s) */
    var DUR = 2100;
    function stepAnim(now) {
      var t = clamp((now - anim.t0) / DUR, 0, 1);
      if (anim.to === 'day') {
        place(moon, lerp(MOON_REST, -4, eio(seg(t, 0, .45))), 1 - seg(t, .32, .45));   // la luna se pone al oeste (derecha)
        place(sun, lerp(184, SUN_REST, eo(seg(t, .3, 1))), seg(t, .3, .42));       // el sol sale por el este (izquierda)
        night = 1 - seg(t, 0, .6); setSky(kf(KF_DAY, t));
        dot.fade = 1 - seg(t, .35, .65); dot.swell = 1 + 2.2 * seg(t, .3, .65); dot.prog = 1;
        if (t >= .38 && !anim.printed) { anim.printed = true; if (day.api) day.api.print(1); else staticPrint(); }
        day.op = day.api ? (anim.printed ? 1 : 0) : seg(t, .38, .5);
      } else {
        place(sun, lerp(SUN_REST, -4, eio(seg(t, 0, .45))), 1 - seg(t, .32, .45));
        place(moon, lerp(184, MOON_REST, eo(seg(t, .35, 1))), seg(t, .35, .47));
        night = seg(t, .4, 1); setSky(kf(KF_NIGHT, t));
        if (!anim.printed) { anim.printed = true; if (day.api) day.api.print(-1); }
        day.op = day.api ? 1 - seg(t, .62, .8) : 1 - seg(t, .1, .45);
        dot.fade = seg(t, .28, .4); dot.swell = 1; dot.prog = seg(t, .3, .9);
      }
      applyDayOp();
      if (t >= .5 && !anim.flipped) { anim.flipped = true; setMode(anim.to); }
      if (t >= 1) {
        bg.style.background = '';
        if (anim.to === 'night') { dot.prog = 1; dot.fade = 1; day.op = 0; } else { dot.fade = 0; dot.swell = 1; day.op = 1; }
        applyDayOp(); anim = null; setTimeout(function () { root.classList.remove('v3-mode-anim'); }, 950);
      }
    }
    function settle(to) {
      night = to === 'night' ? 1 : 0; dot.fade = night; dot.prog = 1; dot.swell = 1; day.op = 1 - night;
      if (to === 'day') loadDay();
      applyDayOp(); restLums(); drawStars(0); drawDots(0); setHud();
    }
    function run(to) { // devuelve false si no hay que animar (fuera de pantalla o movimiento reducido)
      if (RM || !visible) return false;
      if (anim) return true;
      root.classList.add('v3-mode-anim');
      if (to === 'day') loadDay();
      anim = { to: to, t0: performance.now(), flipped: false, printed: false };
      start(); return true;
    }

    function sizeAll() {
      var r = el.getBoundingClientRect(), d = Math.min(window.devicePixelRatio || 1, 2);
      SW = r.width; SH = r.height; sc.width = Math.round(SW * d); sc.height = Math.round(SH * d); sctx.setTransform(d, 0, 0, d, 0, 0);
      var q = pc.getBoundingClientRect(); PW = q.width; PH = q.height; pc.width = Math.round(PW * d); pc.height = Math.round(PH * d); pctx.setTransform(d, 0, 0, d, 0, 0);
      if (!stars.length) for (var i = 0; i < 160; i++) stars.push({ x: Math.random(), y: Math.random() * .86, r: Math.random() * 1.3 + .35, ph: Math.random() * 6.3, th: Math.random() });
      if (day.api) day.api.resize();
      if (!anim) restLums();
      if (RM) { drawStars(0); drawDots(0); }
    }
    sizeAll(); window.addEventListener('resize', sizeAll);
    setHud();
    if (RM) { drawStars(0); drawDots(0); }
    else {
      start();
      var later = function (f) { return window.requestIdleCallback ? window.requestIdleCallback(f, { timeout: 1500 }) : setTimeout(f, 600); }; // rIC 必须以 window 调用，否则 Chrome 抛 Illegal invocation
      if (mode === 'day') later(loadDay); else if (GL_OK) setTimeout(function () { later(loadDay); }, 2500); // precarga en noche, sin prisa
    }
    // reloj de CDMX en la barra inferior
    var clk = $('[data-v3-clock]', el);
    function clock() { try { clk.textContent = 'CDMX · ' + new Intl.DateTimeFormat('es-MX', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'America/Mexico_City' }).format(new Date()); } catch (e) {} }
    if (clk) { clock(); setInterval(clock, 30000); }
    return { run: run, settle: settle };
  })(skyEl);

  /* ================= Adaptador nocturno para contenido no-v3 =================
     Páginas internas mezclan Dawn, estilos v2 con colores fijos y HTML escrito en el admin (con <style> propio).
     Medimos una vez los colores originales y etiquetamos: fondo claro neutro → superficie, texto oscuro → tinta,
     texto gris → tinta 2, borde claro → línea. Sólo actúa de noche (CSS); colores saturados y fotos no se tocan. */
  (function () {
    var SCOPE = 'main, cart-drawer, .cart-drawer, .drawer, predictive-search, .predictive-search, .search-modal, .quick-add-modal, .planeta-nav .mega:not(.v3-mega)';
    var rgb = function (s) { var m = s && s.match(/[\d.]+/g); return m ? m.map(Number) : null; };
    var lum = function (c) { var f = function (v) { v /= 255; return v <= .03928 ? v / 12.92 : Math.pow((v + .055) / 1.055, 2.4); }; return .2126 * f(c[0]) + .7152 * f(c[1]) + .0722 * f(c[2]); };
    var sat = function (c) { return Math.max(c[0], c[1], c[2]) - Math.min(c[0], c[1], c[2]); };
    var opaque = function (c) { return c && (c.length < 4 || c[3] > .5); };
    function effBg(el) { // fondo efectivo original: subimos hasta un fondo opaco
      for (var e = el; e && e !== document.documentElement; e = e.parentElement) {
        if (e._v3bg !== undefined) return e._v3bg;
        var c = rgb(getComputedStyle(e).backgroundColor); if (opaque(c)) return c;
      }
      return null; // la página (tokens de Dawn → ya cambia sola)
    }
    function scan(root) {
      var els = [root].concat(Array.prototype.slice.call(root.querySelectorAll ? root.querySelectorAll('*') : [])), todo = [];
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el._v3done || el.closest('.v3') || /^(IMG|SVG|PATH|VIDEO|CANVAS|PICTURE|SOURCE|IFRAME|SCRIPT|STYLE|BR)$/i.test(el.tagName)) continue;
        el._v3done = 1;
        var cs = getComputedStyle(el), cls = [];
        var bg = rgb(cs.backgroundColor), img = cs.backgroundImage || 'none';
        if (opaque(bg) && sat(bg) < 28 && lum(bg) > .62) cls.push('v3-ad-surf');
        else if (img.indexOf('gradient') > -1 && img.indexOf('url(') < 0) { var g = rgb(img); if (g && sat(g) < 40 && lum(g) > .6) cls.push('v3-ad-surf', 'v3-ad-grad'); }
        el._v3bg = opaque(bg) ? bg : undefined;
        var hasText = false; for (var n = el.firstChild; n; n = n.nextSibling) if (n.nodeType === 3 && n.nodeValue.trim()) { hasText = true; break; }
        if (hasText || /^(INPUT|TEXTAREA|SELECT|LABEL|A|BUTTON)$/.test(el.tagName)) {
          var fg = rgb(cs.color), under = effBg(el);
          var lightUnder = !under || (sat(under) < 28 && lum(under) > .62);
          if (fg && lightUnder && sat(fg) < 50) { var l = lum(fg); if (l < .07) cls.push('v3-ad-ink'); else if (l < .45) cls.push('v3-ad-ink2'); }
        }
        var bd = rgb(cs.borderTopColor);
        if (parseFloat(cs.borderTopWidth) > 0 && bd && sat(bd) < 28 && lum(bd) > .45 && lum(bd) < .95) cls.push('v3-ad-bd');
        if (cls.length) todo.push([el, cls]);
      }
      todo.forEach(function (t) { t[0].classList.add.apply(t[0].classList, t[1]); });
    }
    // medimos con el modo de día (colores tal como fueron escritos) y volvemos al modo actual, sin transiciones visibles
    function measure(fn) {
      var cur = root.getAttribute('data-mode');
      root.classList.add('v3-measure'); root.setAttribute('data-mode', 'day');
      fn();
      root.setAttribute('data-mode', cur); void document.body.offsetHeight;
      requestAnimationFrame(function () { root.classList.remove('v3-measure'); });
    }
    measure(function () { $$(SCOPE).forEach(scan); });
    // contenido que llega después (carrito, búsqueda predictiva, modales)
    if ('MutationObserver' in window) {
      var pend = [], t = null;
      new MutationObserver(function (ms) {
        ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1 && n.closest && n.closest(SCOPE)) pend.push(n.parentElement || n); }); });
        if (pend.length && !t) t = setTimeout(function () { t = null; measure(function () { pend.splice(0).forEach(function (n) { scan(n); }); }); }, 60);
      }).observe(document.body, { childList: true, subtree: true });
    }
  })();

  /* ================= Cursor «cabezal»: punto (boquilla) + retícula con inercia ================= */
  (function () {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var wrap = document.createElement('div'); wrap.className = 'v3-cur'; wrap.setAttribute('aria-hidden', 'true');
    wrap.innerHTML = '<i class="v3-cur__ring"><b style="--a:0deg"></b><b style="--a:90deg"></b><b style="--a:180deg"></b><b style="--a:270deg"></b><span class="v3-cur__lbl"></span></i><i class="v3-cur__dot"></i>';
    document.body.appendChild(wrap);
    var ring = wrap.firstChild, dot = wrap.lastChild, lbl = $('.v3-cur__lbl', wrap);
    var px = -100, py = -100, rx = px, ry = py, on = false, running = false, K = RM ? 1 : .22;
    var INTER = 'a,button,[role="button"],label,select,summary,input[type="checkbox"],input[type="radio"],input[type="submit"],input[type="button"],[data-cursor]';
    var TEXT = 'input:not([type="button"]):not([type="submit"]):not([type="checkbox"]):not([type="radio"]):not([type="range"]),textarea,[contenteditable="true"]';
    function loop() { // la retícula persigue al punto con inercia; el bucle se apaga cuando alcanza
      rx += (px - rx) * K; ry += (py - ry) * K;
      ring.style.transform = 'translate3d(' + rx.toFixed(2) + 'px,' + ry.toFixed(2) + 'px,0) translate(-50%,-50%)';
      if (Math.abs(px - rx) > .15 || Math.abs(py - ry) > .15) requestAnimationFrame(loop); else running = false;
    }
    function kick() { if (!running) { running = true; requestAnimationFrame(loop); } }
    document.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      px = e.clientX; py = e.clientY; dot.style.transform = 'translate3d(' + px + 'px,' + py + 'px,0) translate(-50%,-50%)';
      if (!on) { on = true; rx = px; ry = py; wrap.classList.add('is-on'); root.classList.add('v3-cur-on'); }
      wrap.classList.remove('is-hidden'); kick();
    }, { passive: true });
    document.addEventListener('mouseover', function (e) {
      var el = e.target, text = el.closest && el.closest(TEXT), ifr = el.tagName === 'IFRAME';
      wrap.classList.toggle('is-text', !!text || ifr);
      var it = el.closest && el.closest(INTER), mode = it && it.closest('[data-cursor]'), m = mode ? mode.getAttribute('data-cursor') : '';
      wrap.classList.toggle('is-hover', !!it && !text);
      wrap.classList.toggle('is-orbit', m === 'orbit'); wrap.classList.toggle('is-scan', m === 'scan');
      var l = mode ? (mode.getAttribute('data-cursor-label') || '') : ''; lbl.textContent = l; wrap.classList.toggle('has-lbl', !!l);
    }, { passive: true });
    document.addEventListener('mousedown', function (e) { if (e.button === 0) wrap.classList.add('is-down'); });
    document.addEventListener('mouseup', function () { // al soltar, una onda se expande desde la retícula (misma familia que la gravedad del carrito)
      wrap.classList.remove('is-down'); if (RM) return;
      var p = document.createElement('i'); p.className = 'v3-cur__pulse'; p.style.transform = ring.style.transform; wrap.appendChild(p); p.addEventListener('animationend', function () { p.remove(); });
    });
    document.documentElement.addEventListener('mouseleave', function () { wrap.classList.add('is-hidden'); });
    window.addEventListener('blur', function () { wrap.classList.add('is-hidden'); });
  })();

  /* ================= Contadores (M4) ================= */
  onView($$('[data-v3-count]'), function (n) {
    var to = parseFloat(n.getAttribute('data-v3-count')) || 0; if (RM || !to) { n.textContent = to.toLocaleString('es-MX'); return; }
    var t0 = performance.now();
    (function step(now) { var t = clamp((now - t0) / 900, 0, 1); n.textContent = Math.round(to * eo(t)).toLocaleString('es-MX'); if (t < 1) requestAnimationFrame(step); })(t0);
  });

  /* ================= Títulos que se decodifican (M1) ================= */
  var GLYPHS = '01#%/<>[]=+*ABCDEFXYZ';
  onView($$('[data-v3-decode]'), function (h) {
    if (RM) return;
    var txt = h.textContent, t0 = performance.now(), L = txt.length; h.setAttribute('aria-label', txt);
    (function step(now) {
      var t = clamp((now - t0) / 650, 0, 1), done = Math.floor(eo(t) * L), out = '';
      for (var i = 0; i < L; i++) { var c = txt[i]; out += (i < done || c === ' ') ? c : GLYPHS[(Math.random() * GLYPHS.length) | 0]; }
      h.textContent = out; if (t < 1) requestAnimationFrame(step); else { h.textContent = txt; h.removeAttribute('aria-label'); }
    })(t0);
  });

  /* ================= Escaneo de imágenes (M3) ================= */
  var PIN = window.matchMedia('(min-width: 1000px) and (min-height: 700px) and (prefers-reduced-motion: no-preference)');
  onView($$('[data-v3-scan]').filter(function (f) { return !(PIN.matches && f.closest('[data-v3-sys]')); }), function (f) { f.classList.add('is-in'); });

  /* ================= 02 Sistemas: escáner fijado, el scroll cambia de serie (M2 + M3) ================= */
  function scramble(el, ms) { // decodificación corta para lecturas de datos
    if (RM || !el) return; var txt = el.getAttribute('data-txt') || el.textContent; el.setAttribute('data-txt', txt);
    var t0 = performance.now(), L = txt.length;
    (function step(now) {
      var t = clamp((now - t0) / ms, 0, 1), done = Math.floor(eo(t) * L), out = '';
      for (var i = 0; i < L; i++) { var c = txt[i]; out += (i < done || c === ' ' || c === '·') ? c : GLYPHS[(Math.random() * GLYPHS.length) | 0]; }
      el.textContent = out; if (t < 1) requestAnimationFrame(step); else el.textContent = txt;
    })(t0);
  }
  var sys = $('[data-v3-sys]');
  if (sys) (function () {
    var panels = $$('[data-v3-panel]', sys), tabs = $$('[data-v3-tab]', sys), track = $('.v3-sys__track', sys), prog = $('.v3-sys__prog', sys), num = $('[data-v3-sysn]', sys), cur = -1;
    function coords(stage, w, h) {
      var el = $('[data-v3-coords]', stage); if (!el) return;
      var W = +w || 256, H = +h || 256, f = function (v) { return ('00' + v.toFixed(1)).slice(-5); };
      if (RM) { el.textContent = 'X ' + f(W / 2) + ' · Y ' + f(W / 2) + ' · Z ' + f(H); return; }
      var t0 = performance.now();
      (function step(now) { var t = clamp((now - t0) / 1000, 0, 1), e = eo(t); el.textContent = 'X ' + f(W / 2 * e) + ' · Y ' + f(W / 2 * Math.min(1, e * 1.2)) + ' · Z ' + f(H * e); if (t < 1) requestAnimationFrame(step); })(t0);
    }
    // el escáner: cambia el recorte, actualiza cotas y lecturas, y vuelve a escanear (nube de puntos → pieza sólida)
    function scan(stage, d) {
      if (!stage) return; var img = $('[data-v3-stage-img]', stage);
      if (img && d.cut && img.getAttribute('src') !== d.cut) img.src = d.cut;
      var set = function (sel, v) { var n = $(sel, stage); if (n) n.textContent = v || ''; };
      set('[data-v3-sname]', d.name); set('[data-v3-sprice]', d.price);
      set('[data-v3-dw]', d.w ? d.w + ' mm' : ''); set('[data-v3-dh]', d.h ? d.h + ' mm' : '');
      if (RM) return;
      stage.classList.remove('is-scan'); void stage.offsetWidth; stage.classList.add('is-scan');
      coords(stage, d.w, d.h); stage._shown = d.cut;
    }
    function printLetter(p) { p.classList.remove('is-print'); void p.offsetWidth; p.classList.add('is-print'); }
    panels.forEach(function (p) {
      var st = $('[data-v3-stage]', p); if (!st) return;
      var img = $('[data-v3-stage-img]', st);
      st._hero = { cut: img ? img.getAttribute('src') : '', name: st.getAttribute('data-name'), price: st.getAttribute('data-price'), w: st.getAttribute('data-w'), h: st.getAttribute('data-h') };
      var rows = $$('.v3-row', p);
      rows.forEach(function (r) {
        ['mouseenter', 'focusin'].forEach(function (ev) {
          r.addEventListener(ev, function () {
            if (!r.getAttribute('data-cut')) return;
            rows.forEach(function (x) { x.classList.toggle('is-hot', x === r); });
            if (st._shown === r.getAttribute('data-cut')) return;
            scan(st, { cut: r.getAttribute('data-cut'), name: r.getAttribute('data-name'), price: r.getAttribute('data-price'), w: r.getAttribute('data-w'), h: r.getAttribute('data-h') });
          });
        });
      });
      var list = $('.v3-rows', p);
      if (list) list.addEventListener('mouseleave', function () { rows.forEach(function (x) { x.classList.remove('is-hot'); }); if (st._shown !== st._hero.cut) scan(st, st._hero); });
      // precarga los recortes de la serie la primera vez que el cursor entra
      p.addEventListener('mouseenter', function () { rows.forEach(function (r) { var c = r.getAttribute('data-cut'); if (c) { var i = new Image(); i.src = c; } }); }, { once: true });
    });
    function activate(i) {
      if (i === cur) return; cur = i;
      panels.forEach(function (p, k) {
        p.classList.toggle('is-on', k === i);
        if (k === i && PIN.matches) {
          printLetter(p); var st = $('[data-v3-stage]', p); if (st) scan(st, st._hero);
          $$('.v3-specs dd', p).forEach(function (d) { scramble(d, 520); });
        }
      });
      tabs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (num) num.textContent = ('0' + (i + 1)).slice(-2);
    }
    var ticking = false;
    function update() {
      ticking = false; if (!PIN.matches) return;
      var r = track.getBoundingClientRect(), total = track.offsetHeight - window.innerHeight, p = clamp(-r.top / Math.max(1, total), 0, 1);
      if (prog) prog.style.setProperty('--p', p.toFixed(3));
      if (r.top < window.innerHeight * .6) activate(Math.min(panels.length - 1, Math.floor(p * panels.length * .999)));
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () {
        if (PIN.matches) {
          var top = track.getBoundingClientRect().top + window.scrollY, total = track.offsetHeight - window.innerHeight;
          window.scrollTo({ top: top + total * (k + .5) / panels.length, behavior: RM ? 'auto' : 'smooth' });
        } else panels[k].scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' });
      });
    });
    if (PIN.matches) { panels.forEach(function (p, k) { p.classList.toggle('is-on', k === 0); }); update(); }
    else onView(panels, function (p) { printLetter(p); var st = $('[data-v3-stage]', p); if (st) scan(st, st._hero); }, { rootMargin: '0px 0px -20% 0px' });
  })();

  /* ================= Colección: chips de serie + orden ================= */
  $$('[data-v3-chips]').forEach(function (g) {
    var grid = document.getElementById(g.getAttribute('data-v3-chips'));
    g.addEventListener('click', function (e) {
      var b = e.target.closest('[data-serie]'); if (!b || !grid) return;
      var v = b.getAttribute('data-serie');
      $$('[data-serie]', g).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      $$('.v3-card', grid).forEach(function (c) { c.hidden = v !== 'all' && c.getAttribute('data-serie') !== v; });
    });
  });
  $$('[data-v3-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); location.href = u.toString(); });
  });

  /* ================= Manifiesto palabra por palabra ================= */
  $$('[data-v3-words]').forEach(function (m) {
    var ws = $$('.w', m); if (RM) { ws.forEach(function (w) { w.classList.add('on'); }); return; }
    var ticking = false;
    function update() {
      ticking = false; var r = m.getBoundingClientRect(), vh = window.innerHeight;
      var p = clamp((vh * .85 - r.top) / (r.height + vh * .35), 0, 1), lit = Math.round(p * ws.length);
      ws.forEach(function (w, i) { w.classList.toggle('on', i < lit); });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  });

  /* ================= Léxico de movimiento de los botones ================= */
  // Ondas: WhatsApp — el sonido se propaga
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-v3-ping]'); if (!b) return;
    b.classList.add('is-ping'); setTimeout(function () { b.classList.remove('is-ping'); }, 1600);
  });
  // Luciérnagas: «Avísame» — pequeñas luces que se quedan esperando
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-v3-firefly]'); if (!b || RM) return;
    var r = b.getBoundingClientRect();
    for (var i = 0; i < 7; i++) {
      var f = document.createElement('span'); f.className = 'v3-firefly';
      f.style.left = (r.left + 12 + Math.random() * (r.width - 24)) + 'px'; f.style.top = (r.top + r.height / 2) + 'px';
      f.style.setProperty('--dx', (Math.random() * 40 - 20).toFixed(0) + 'px'); f.style.setProperty('--d', (1.9 + Math.random() * 1.1).toFixed(2) + 's'); f.style.animationDelay = (i * .12) + 's';
      document.body.appendChild(f); f.addEventListener('animationend', function () { this.remove(); });
    }
  });
  // Gravedad: «Agregar» — el producto cae en parábola al carrito y el carrito ondula al recibirlo
  function cartIcon() { return document.getElementById('cart-icon-bubble'); }
  function landCart() {
    var c = cartIcon(); if (!c || RM) return;
    c.classList.remove('v3-bump'); void c.offsetWidth; c.classList.add('v3-bump');
    var r = c.getBoundingClientRect();
    [0, 180].forEach(function (dl) { setTimeout(function () { var ring = document.createElement('span'); ring.className = 'v3-ripple'; ring.style.left = (r.left + r.width / 2) + 'px'; ring.style.top = (r.top + r.height / 2) + 'px'; document.body.appendChild(ring); ring.addEventListener('animationend', function () { ring.remove(); }); }, dl); });
  }
  function fly(btn, color, done) {
    var c = cartIcon(); if (RM || !c) { done(); return; }
    var b = btn.getBoundingClientRect(), q = c.getBoundingClientRect(), x0 = b.left + b.width / 2, y0 = b.top + b.height / 2, x1 = q.left + q.width / 2, y1 = q.top + q.height / 2;
    var T = 800, g = .0024, vy = ((y1 - y0) - .5 * g * T * T) / T, d = document.createElement('span'); d.className = 'v3-fly'; d.style.background = color || '#903EFF'; document.body.appendChild(d);
    var t0 = performance.now();
    (function step(now) {
      var t = Math.min(T, now - t0), x = lerp(x0, x1, t / T), y = y0 + vy * t + .5 * g * t * t, s = 1 - .4 * (t / T);
      d.style.transform = 'translate(' + (x - 7) + 'px,' + (y - 7) + 'px) scale(' + s + ')';
      if (t < T) requestAnimationFrame(step); else { d.remove(); done(); }
    })(t0);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-v3-add]'); if (!b || b.disabled) return;
    e.preventDefault(); var lbl = b.textContent; b.disabled = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +b.getAttribute('data-v3-add'), quantity: 1 }], sections: 'cart-icon-bubble' })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }).then(function (res) {
      if (!res.ok) { b.textContent = 'Agotado'; setTimeout(function () { b.textContent = lbl; b.disabled = false; }, 1600); return; }
      fly(b, b.getAttribute('data-color'), function () {
        var html = res.j.sections && res.j.sections['cart-icon-bubble'], c = cartIcon();
        if (html && c) { var tmp = document.createElement('div'); tmp.innerHTML = html; var fresh = tmp.querySelector('#cart-icon-bubble') || tmp.querySelector('.shopify-section'); if (fresh) c.innerHTML = fresh.innerHTML; }
        landCart(); b.classList.add('is-done'); b.textContent = 'Agregado ✓';
        setTimeout(function () { b.classList.remove('is-done'); b.textContent = lbl; b.disabled = false; }, 1400);
      });
    }).catch(function () { b.textContent = lbl; b.disabled = false; });
  });
})();
